export var COBStep = /*#__PURE__*/ function(COBStep) {
    COBStep["welcome"] = "welcome";
    COBStep["selectAPackage"] = "packages";
    COBStep["reviewServices"] = "services";
    COBStep["termsOfService1"] = "terms-of-service-1";
    COBStep["termsOfService2"] = "terms-of-service-2";
    COBStep["termsOfService3"] = "terms-of-service-3";
    COBStep["termsOfService4"] = "terms-of-service-4";
    COBStep["approveTerms"] = "terms";
    COBStep["accountantAccess"] = "accountant-access";
    COBStep["paymentMethod"] = "payment-method";
    COBStep["allSet"] = "all-set";
    COBStep["introduction"] = "introduction";
    COBStep["signAndApprove"] = "sign-and-approve";
    COBStep["customPage1"] = "custom-page-1";
    COBStep["customPage2"] = "custom-page-2";
    COBStep["customPage3"] = "custom-page-3";
    COBStep["customPage4"] = "custom-page-4";
    COBStep["customPage5"] = "custom-page-5";
    COBStep["customPage6"] = "custom-page-6";
    COBStep["customPage7"] = "custom-page-7";
    COBStep["customPage8"] = "custom-page-8";
    COBStep["customPage9"] = "custom-page-9";
    COBStep["customPage10"] = "custom-page-10";
    return COBStep;
}({});
